import { selectEntity } from '@hozana/api/selectors'

import type { TState } from 'config/types'

export const selectCommunity = (state: TState, communityId: number) => selectEntity(state, 'community', communityId)
